import { Button, Chip, Divider, Grid, Paper, Stack, Typography } from "@mui/material";
import { StaffData } from "../../Objects/StaffData";

export interface StaffCardProps {
    staffData: StaffData
    onEdit: (staffData: StaffData) => void
    onDelete: (staffData: StaffData) => void
}

export default function StaffCard({
    staffData,
    onEdit,
    onDelete,
}: StaffCardProps): React.ReactElement {
    if (!staffData.login_str) {
        return (
            <Paper
                sx={{
                    p: 2,
                    height: "100%",
                    backgroundColor: '#eee'
                }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Stack spacing={1}>
                            <Typography variant="h3">(抹消済み) [{staffData.stf_id}] {staffData.stf_name}</Typography>
                        </Stack>
                    </Grid>
                </Grid>
            </Paper>

        )
    }
    return (
        <Paper
            sx={{
                p: 2,
                height: "100%",
            }}
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Stack spacing={1}>
                        <Typography variant="h3">[{staffData.stf_id}] {staffData.stf_name}</Typography>
                        <Typography variant="body2" textAlign="right">{staffData.login_str}</Typography>
                        <Divider />
                        <Grid container spacing={{ xs: 0, md: 2 }} rowSpacing={0.1} alignItems="center">
                            <Grid item xs={12} md={3}><Typography variant="subtitle2" textAlign={{ xs: "left", md: "right" }}>認証コード</Typography></Grid>
                            <Grid item xs={12} md={9}><Typography variant="body1" textAlign={{ xs: "right", md: "left" }}>{staffData.stf_code ? staffData.stf_code : "-"}</Typography></Grid>
                        </Grid>
                        <Grid container spacing={{ xs: 0, md: 2 }} rowSpacing={0.1} alignItems="center">
                            <Grid item xs={12} md={3}><Typography variant="subtitle2" textAlign={{ xs: "left", md: "right" }}>Email</Typography></Grid>
                            <Grid item xs={12} md={9}><Typography variant="body1" textAlign={{ xs: "right", md: "left" }}>{staffData.stf_mail ? staffData.stf_mail : "-"}</Typography></Grid>
                        </Grid>
                        <Grid container spacing={{ xs: 0, md: 2 }} rowSpacing={0.1} alignItems="center">
                            <Grid item xs={12} md={3}><Typography variant="subtitle2" textAlign={{ xs: "left", md: "right" }}>Tel</Typography></Grid>
                            <Grid item xs={12} md={9}><Typography variant="body1" textAlign={{ xs: "right", md: "left" }}>{staffData.stf_tel ? staffData.stf_tel : "-"}</Typography></Grid>
                        </Grid>
                        <Grid container spacing={0} rowSpacing={0.1} alignItems="center">
                            <Grid item xs={12}><Typography variant="subtitle2">アクセス権限</Typography></Grid>
                            <Grid item xs={12}>
                                {staffData.access_level &&
                                    <Chip label={staffData.access_level}
                                        variant="outlined"
                                        size="small"
                                    />
                                }
                            </Grid>
                        </Grid>
                        <Grid container spacing={0} rowSpacing={0.1} alignItems="center">
                            <Grid item xs={12}><Typography variant="subtitle2">管理店舗一覧</Typography></Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={1} rowSpacing={0.7}>
                                    {staffData.admin_str_name_list?.map((value, index) => (
                                        <Grid item key={index}>
                                            <Chip label={value}
                                                variant="outlined"
                                                size="small"
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Stack>
                </Grid>
                <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                    <Stack direction="row"
                        spacing={2}
                        justifyContent="right"
                    >
                        <Button
                            variant="outlined"
                            onClick={() => {
                                onEdit(staffData)
                            }}
                        >編集</Button>
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={() => {
                                onDelete(staffData)
                            }}
                        >登録抹消</Button>
                    </Stack>
                </Grid>
            </Grid>
        </Paper>
    )
}